import envConfig from '../../static/config';
import config from '../config';
import ApiUtils from './ApiUtils';
import PreferenceActionCreator from '../actions/PreferenceActionCreator';

const _getBusinessPreferencesEndpoint =
  '/ibapi/v2/banks/{bank-id}/customers/{customer-id}/preferences';
const _getPreferencesEndpoint = '/ibapi/v2/user/preferences';

class PreferencesApiUtils {
  static getPreferences(onSuccess = () => {}, onError = () => {}) {
    const url = `${envConfig.apiBaseUrlPAAS}${_getPreferencesEndpoint}`;

    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.preferenceServices,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body, status) => {
        PreferenceActionCreator.handleGetPreferencesSuccess(body);
        onSuccess(body);
      },
      (error, status) => {
        PreferenceActionCreator.handleGetPreferencesError(error);
        onError();
      }
    );
  }

  static getBusinessPreferences(
    customerId,
    onSuccess = () => {},
    onError = () => {}
  ) {
    let url = `${envConfig.apiBaseUrlPAAS}${_getBusinessPreferencesEndpoint}`;
    url = url.replace('{customer-id}', customerId);

    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.preferenceServices,
        method: 'GET',
        url,
        addAuthToken: true,
      },
      (body, status) => {
        PreferenceActionCreator.setPreferences(body);
      },
      (error, status) => {}
    );
  }

  static updatePreferences(preferences) {
    const requestData = JSON.stringify(preferences);
    const url = `${envConfig.apiBaseUrlPAAS}${_getPreferencesEndpoint}`;

    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.preferenceServices,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        PreferenceActionCreator.handleUpdatePreferencesSuccess(body);
      },
      (error) => {
        PreferenceActionCreator.handleUpdatePreferencesError(error);
      }
    );
  }
}

export default PreferencesApiUtils;
